import { getFontSize } from '../../constants/fontSizes';

export const assetUploadStyles = () => {
  return {
    container: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: '16px',
      alignItems: 'flex-start',
    },
    uploadButton: {
      width: '90px',
      height: '70px',
      borderRadius: '14px',
      border: '2px dashed',
      borderColor: 'primary.main',
      backgroundColor: '#00443F14',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      padding: '17px 24px',
      '&:hover': {
        backgroundColor: '#00443F24',
      },
    },
    plusIcon: {
      color: 'primary.main',
      fontSize: 32,
      fontWeight: 300,
      lineHeight: 1,
    },
    previewGrid: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: '16px',
    },
    previewItem: {
      position: 'relative',
      width: '90px',
      height: '70px',
      borderRadius: '14px',
      overflow: 'hidden',
      cursor: 'pointer',
      '&:hover .close-button': {
        opacity: 1,
      },
    },
    previewImage: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
    },
    previewVideo: {
      position: 'relative',
      width: '100%',
      height: '100%',
    },
    playIconOverlay: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    playIcon: {
      color: 'secondary.main',
      fontSize: getFontSize(32),
    },
    closeButton: {
      position: 'absolute',
      top: '4px',
      right: '4px',
      width: '24px',
      height: '24px',
      borderRadius: '50%',
      backgroundColor: 'rgba(0, 0, 0, 0.6)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      opacity: 0,
      transition: 'opacity 0.2s',
      '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
      },
    },
    closeIcon: {
      color: 'secondary.main',
      fontSize: getFontSize(16),
    },
    dialogPaper: {
      backgroundColor: 'transparent',
      boxShadow: 'none',
      maxWidth: '90vw',
      maxHeight: '90vh',
      position: 'relative',
    },
    dialogImage: {
      maxWidth: '100%',
      maxHeight: '90vh',
      objectFit: 'contain',
    },
    dialogVideo: {
      maxWidth: '100%',
      maxHeight: '90vh',
    },
    dialogCloseButton: {
      position: 'absolute',
      top: '16px',
      right: '16px',
      backgroundColor: 'rgba(0, 0, 0, 0.6)',
      color: 'secondary.main',
      '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
      },
    },
  };
};

